import { servObj } from './init_glob';

const saveFile = (strData, filename) => {
    const link = document.createElement('a');
    if (typeof link.download === 'string') {
        document.body.appendChild(link);
        link.download = filename;
        link.href = strData;
        link.click();
        document.body.removeChild(link);
    } else {
        location.replace(uri);
    }
};
const saveAsImage = () => {
    requestAnimationFrame(() => {
        try {
            const strMime = 'image/jpeg';
            const strDownloadMime = 'image/octet-stream';
            const imgData = servObj.scene.activeRenderer.domElement.toDataURL(strMime);
            saveFile(imgData.replace(strMime, strDownloadMime), 'test.jpg');
        } catch (e) {
            console.error('Ошибка сохранения:', e);
        }
    });
};

document.querySelectorAll('.screenshot').forEach((btn) => {
    btn.addEventListener('pointerdown', saveAsImage);
});
